<div class="flex flex-col wrapper w-100-percent">
    <mat-icon svgIcon="close" class="close-icon w-64 p-10 h-64 white-bg mt--100 ml-256" [mat-dialog-close]="null"></mat-icon>
    <div class="mat-headline-4 mb-10">{{'HELP_CENTER.TITLE' | transloco}}</div>
    <mat-divider class="mb-24 mt-24"></mat-divider>
    <div class="mat-headline-6 mb-10 cursor-pointer">{{'HELP_CENTER.RESOURCES' | transloco}}</div>
    <div class="mat-headline-6 mb-10 cursor-pointer">{{'HELP_CENTER.Q/A' | transloco}}</div>
    <div class="mat-headline-6 mb-10 cursor-pointer">{{'HELP_CENTER.TICKET_ISSUE' | transloco}}</div>
    <div class="mat-headline-6 mb-10 cursor-pointer">{{'HELP_CENTER.BASECAMP_LINK' | transloco}}</div>
    <mat-divider class="mt-24 mb-24"></mat-divider>
    <div class="mat-headline-6 mb-10">{{'HELP_CENTER.TEMENOS_SUPPORT' | transloco}}</div>
    <div class="mat-body mb-5">{{'HELP_CENTER.MORE_HELP' | transloco}}</div>
    <div class="mat-body mb-10">{{'HELP_CENTER.SUPPORT_TEXT' | transloco}}</div>
    <div class="w-100-percent mt-20">
      <button class="accent rounded" (click)="openContactUs()" type="button">
        {{'HELP_CENTER.CONTACT_US_BTN' | transloco }} </button>
    </div>
  </div>